import { jsx } from "panel";
import difference from "lodash/difference";
import { SwitchEl } from "common/components/switch";
import { TooltipEl } from "common/components/tooltip";
import { ToggleEl } from "common/components/toggle";
import { ToggleSize } from "common/components/toggle/types";
import { baseComparator } from "common/util";
import { OrderBy } from "common/util/array";
import { SvgIconEl } from "common/components/svg-icon";
import { trackClick } from "../table-cell-mixins";
export function template() {
  const RowContents = () => {
    const event = this.helpers.getFilteredEvent();
    if (this.helpers.isJsonView()) {
      return /* @__PURE__ */ jsx("pre", {
        sel: ".expanded-row-json"
      }, JSON.stringify(event, null, 2));
    } else {
      const properties = { ...event.properties };
      const pinnedKeys = this.helpers.getPinnedProperties();
      if (pinnedKeys.length) {
        const missingKeys = difference(pinnedKeys, Object.keys(properties));
        missingKeys.forEach((missingKey) => {
          properties[missingKey] = ``;
        });
      }
      let sortedAvailablePropertyKeys = Object.keys(properties).sort(
        baseComparator({ order: OrderBy.Ascending, transform: (item) => item.toLowerCase() })
      );
      if (pinnedKeys.length) {
        sortedAvailablePropertyKeys = sortedAvailablePropertyKeys.sort((a, b) => {
          const aPinned = pinnedKeys.includes(a);
          const bPinned = pinnedKeys.includes(b);
          if (aPinned && !bPinned) {
            return -1;
          } else if (bPinned) {
            return 1;
          } else {
            return 0;
          }
        });
      }
      const numProps = sortedAvailablePropertyKeys.length;
      const itemsPerColumn = Math.ceil(numProps / 3);
      return /* @__PURE__ */ jsx("div", {
        sel: ".expanded-row-grid"
      }, sortedAvailablePropertyKeys.map((key, index) => {
        const col = Math.floor(index / itemsPerColumn) + 1;
        const isLastItemInCol = index === numProps - 1 || (index + 1) % itemsPerColumn === 0;
        const value = properties[key].formattedValue;
        const href = properties[key].href;
        const raw = properties[key].raw;
        return /* @__PURE__ */ jsx("div", {
          sel: ".expanded-row-grid-item",
          class: {
            [`expanded-row-grid-item-col-${col}`]: true,
            "expanded-row-last-item-in-col": isLastItemInCol
          }
        }, this.attr(`allow-pinning`) && /* @__PURE__ */ jsx("div", {
          sel: ".expanded-row-pin",
          class: { "expanded-row-pinned": this.helpers.isPinned(key) },
          on: {
            click: () => {
              this.helpers.onPinClick(key);
            }
          }
        }, /* @__PURE__ */ jsx(SvgIconEl, {
          attrs: { icon: `pin` }
        })), /* @__PURE__ */ jsx("div", {
          sel: ".expanded-row-label",
          class: { "expanded-row-truncate": (key == null ? void 0 : key.length) > 20 },
          attrs: { title: key }
        }, `${key}:`), /* @__PURE__ */ jsx("div", {
          sel: ".expanded-row-item-text"
        }, href ? /* @__PURE__ */ jsx("a", {
          attrs: { href, target: `_blank`, rel: `noopener noreferrer` },
          on: { click: (ev) => trackClick(ev, href, key) }
        }, value) : value, /* @__PURE__ */ jsx(TooltipEl, null, typeof raw === `string` ? raw : value)));
      }));
    }
  };
  return /* @__PURE__ */ jsx("div", {
    sel: ".expanded-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".expanded-row-header"
  }, !this.attr(`hide-property-key-filter`) && /* @__PURE__ */ jsx(ToggleEl, {
    attrs: {
      selected: this.attr(`property-key-filter`),
      size: ToggleSize.Medium,
      theme: this.attr(`toggletheme`),
      options: this.helpers.getPropertyKeyFilter()
    },
    on: {
      select: this.helpers.onSelectPropertyKeyFilter
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".expanded-row-switch"
  }, /* @__PURE__ */ jsx(SwitchEl, {
    attrs: { on: this.helpers.isJsonView() },
    on: { change: this.helpers.onChangeViewFormat }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".expanded-row-switch-label"
  }, "JSON mode"))), /* @__PURE__ */ jsx(RowContents, null));
}
